// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.level-indicator-container,
.level-indicator-element {
  display: flex;
  flex-direction: row;
  gap: calc(calc(var(--input-element-gap) - 2px) / 2);
  align-items: center;
}

.level-indicator-point {
  width: var(--input-element-gap);
  height: var(--input-element-gap);
  border-radius: 50%;
}

.level-indicator-point-red {
  background-color: var(--error-color);
}

.level-indicator-point-green {
  background-color: var(--success-color);
}

.level-indicator-point-yellow {
  background-color: var(--warn-color);
}

.level-indicator-point-grey {
  background-color: var(--light-grey);
}

.level-indicator-spacer,
.level-indicator-spacer-max {
  width: 2px;
  height: var(--input-element-gap);
}

.level-indicator-spacer {
  background: transparent;
}

.level-indicator-spacer-max {
  background: var(--info-color);
  box-shadow: 0px 0px 2px 0px var(--info-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/device-settings/audio-settings/level-indicator/LevelIndicator.component.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C","sourcesContent":[".level-indicator-container,\n.level-indicator-element {\n  display: flex;\n  flex-direction: row;\n  gap: calc(calc(var(--input-element-gap) - 2px) / 2);\n  align-items: center;\n}\n\n.level-indicator-point {\n  width: var(--input-element-gap);\n  height: var(--input-element-gap);\n  border-radius: 50%;\n}\n\n.level-indicator-point-red {\n  background-color: var(--error-color);\n}\n\n.level-indicator-point-green {\n  background-color: var(--success-color);\n}\n\n.level-indicator-point-yellow {\n  background-color: var(--warn-color);\n}\n\n.level-indicator-point-grey {\n  background-color: var(--light-grey);\n}\n\n.level-indicator-spacer,\n.level-indicator-spacer-max {\n  width: 2px;\n  height: var(--input-element-gap);\n}\n\n.level-indicator-spacer {\n  background: transparent;\n}\n\n.level-indicator-spacer-max {\n  background: var(--info-color);\n  box-shadow: 0px 0px 2px 0px var(--info-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
